import { Typography } from "@mui/material";
import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { formatPercentage } from "Infrastructure/Utils/NumberUtils";
import { differenceInYears } from "date-fns";
import { ModelingHint } from "./ModelingHint";

type Props = {
  readonly startDate: Date;
  readonly referenceStartDate: Date;
  readonly targetAmount: number;
  readonly interestRate: number;
  readonly monthlyContribution: number;
};

export const OtherGoalModelingHint: React.FC<Props> = ({
  startDate,
  targetAmount,
  interestRate,
  monthlyContribution,
  referenceStartDate,
}) => {
  const { t } = useResource();
  return (
    <ModelingHint title={t(Resources.AnalysisDetail.Goals.OtherGoalHint.Title)}>
      {t(Resources.AnalysisDetail.Goals.OtherGoalHint.FirstPhrase)}{" "}
      <Typography display="inline" component="span" variant="body2" fontWeight={500}>
        {formatCurrency(targetAmount, CurrencyCode.CZK)}
      </Typography>
      . {t(Resources.AnalysisDetail.Goals.OtherGoalHint.SecondPhrase)}{" "}
      <Typography display="inline" component="span" variant="body2" fontWeight={500}>
        {formatPercentage(interestRate)}
      </Typography>{" "}
      {t(Resources.AnalysisDetail.Goals.OtherGoalHint.WithMonthlyInvestment)}{" "}
      <Typography display="inline" component="span" variant="body2" fontWeight={500}>
        {formatCurrency(monthlyContribution, CurrencyCode.CZK)}
      </Typography>{" "}
      {t(Resources.AnalysisDetail.Goals.OtherGoalHint.ForDuration)}{" "}
      <Typography display="inline" component="span" variant="body2" fontWeight={500}>
        {differenceInYears(startDate, referenceStartDate)} {t(Resources.Common.Years)}
      </Typography>
      .
    </ModelingHint>
  );
};
